import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "team",
  class: "team-wrap pb-75"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "team-card style3" }
const _hoisted_6 = { class: "team-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "team-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-xl-6 offset-xl-3 col-lg-8 offset-lg-2" }, [
          _createElementVNode("div", { class: "section-title style3 text-center mb-40" }, [
            _createElementVNode("span", null, "Our Doctors"),
            _createElementVNode("h2", null, [
              _createTextVNode(" We provide "),
              _createElementVNode("span", null, "Exceptional Medical"),
              _createTextVNode(" Care For Our Patients ")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-4 col-md-6",
            key: team.id,
            "data-aos": "fade-right",
            "data-aos-duration": "1200",
            "data-aos-delay": team.datadelay
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: team.image,
                  alt: "Image"
                }, null, 8, _hoisted_7),
                _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"social-link\"><span><i class=\"flaticon-share\"></i></span><ul class=\"social-profile list-style style1\"><li><a target=\"_blank\" href=\"https://facebook.com\"><i class=\"ri-facebook-line\"></i></a></li><li><a target=\"_blank\" href=\"https://twitter.com\"><i class=\"ri-twitter-line\"></i></a></li><li><a target=\"_blank\" href=\"https://instagram.com\"><i class=\"ri-instagram-line\"></i></a></li><li><a target=\"_blank\" href=\"https://linkedin.com\"><i class=\"ri-linkedin-line\"></i></a></li></ul></div>", 1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", null, _toDisplayString(team.name), 1),
                _createElementVNode("span", null, _toDisplayString(team.designation), 1)
              ])
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}